module.exports = __webpack_public_path__ + "static/media/wave-chart.32c0429d.svg";